<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>
					<span v-if="taskOnlineUserModel.id === 0"> افزودن کاربر </span>
					<span v-else> ویرایش کاربر </span>

				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage">
					<i class="font-16 fa fa-redo"></i>
				</button>
			</div>

			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active': taskOnlineUserModel.userTitle !== null,}">نام و نام خانوادگی</span>
						<input :readOnly="taskOnlineUserModel.payedMonthCount> 0 ||	taskOnlineUserModel.adminOrUser === true" class="form-control" type="text" v-model="taskOnlineUserModel.userTitle" @input="v$.taskOnlineUserModel.userTitle.$touch()" :class="{ invalid: v$.taskOnlineUserModel.userTitle.$error }" />
						<p class="text-danger" v-if="v$.taskOnlineUserModel.userTitle.required.$invalid && v$.taskOnlineUserModel.userTitle.$dirty">
							لطفا نام و نام خانوادگی را وارد کنید.
						</p>
					</div>
					<div class="input-style input-style-2 has-icon input-required" v-show="taskOnlineUserModel.registByEmail.toString() == 'false'">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active':taskOnlineUserModel.phoneNumber !== null,}">شماره تلفن همراه</span>
						<input id="userPhoneNumber" :readOnly="taskOnlineUserModel.payedMonthCount> 0 || taskOnlineUserModel.adminOrUser === true || taskOnlineUserModel.id > 0" class="form-control text-left ltr" type="tel" v-model="taskOnlineUserModel.phoneNumber" @input="v$.taskOnlineUserModel.phoneNumber.$touch()" :class="{ invalid: v$.taskOnlineUserModel.phoneNumber.$error }" maxlength="11"/>
						<p class="text-danger" v-if="v$.taskOnlineUserModel.phoneNumber.requiredIfFuctionPhone.$invalid && v$.taskOnlineUserModel.phoneNumber.$dirty">
							لطفا شماره تلفن همراه را وارد کنید.
						</p>
					</div>
					<div class="input-style input-style-2 has-icon input-required" v-show="taskOnlineUserModel.registByEmail.toString() == 'true'">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active':taskOnlineUserModel.emailAddress !== null,}">آدرس ایمیل</span>
						<input :readOnly="taskOnlineUserModel.payedMonthCount> 0 || taskOnlineUserModel.adminOrUser === true ||	taskOnlineUserModel.id > 0" class="form-control text-left ltr" type="email" v-model="taskOnlineUserModel.emailAddress" @input="v$.taskOnlineUserModel.emailAddress.$touch()" :class="{ invalid: v$.taskOnlineUserModel.emailAddress.$error }" />
						<p class="text-danger" v-if="v$.taskOnlineUserModel.emailAddress.requiredIfFuction.$invalid && v$.taskOnlineUserModel.emailAddress.$dirty">
							لطفا آدرس ایمیل را وارد کنید.
						</p>
					</div>

					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-file-alt color-magenta2-light"></i>
						<span class="color-highlight input-style-1-active">جنسیت</span>
						<select class="form-control" type="text" v-model="taskOnlineUserModel.gender">
							<option value="true">مرد</option>
							<option value="false">زن</option>
						</select>
					</div>

					<div class="py-3 list-custom-small">
						<div class="list-group-div border-0">
							<i class="fa fa-calendar color-magenta2-light"></i>
							<span class="font-weight-bold" :class="{'input-style-1-active':taskOnlineUserModel.monthCount !== null,}">تعداد ماه</span>
							<div>
								<div class="row mb-0 pr-3">
									<div class="col-4 d-flex align-items-center py-2 pr-0">
										<input class="m-0" type="radio" name="MonthCount" @change="changeMonthRadio(1)" checked style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14">
											1 ماه
										</label>
									</div>
									<div class="col-4 d-flex align-items-center py-2 pr-0">
										<input class="m-0" type="radio" name="MonthCount" @change="changeMonthRadio(6)" style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14">
											6 ماه
										</label>
									</div>
									<div class="col-4 d-flex align-items-center py-2 pr-0">
										<input class="m-0" type="radio" name="MonthCount" @change="changeMonthRadio(12)" style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14">
											12 ماه
										</label>
									</div>
								</div>
								<!--<div class="row mb-0 pr-3">-->
									<!--<div class="col-6 d-flex align-items-center py-2 pr-0">
										<input class="m-0" type="radio" name="MonthCount" @change="changeMonthRadio(3)" style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14">
											3 ماه
										</label>
									</div>-->
									<!--<div class="col-6 d-flex align-items-center py-2 pr-0">
										<input class="m-0" type="radio" name="MonthCount" @change="changeMonthRadio(12)" style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14">
											12 ماه
										</label>
									</div>
								</div>-->

								<!--<button type="button" class="btn btn-link p-0" @click="changeMonth(-1)"><i class="fa font-14 fa-minus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i></button>
								<span class="font-weight-bold text-center d-inline-block" style="width: 50px">{{ taskOnlineUserModel.monthCount-taskOnlineUserModel.payedMonthCount }}</span>
								<button type="button" class="btn btn-link p-0" @click="changeMonth(1)"><i class="fa font-14 fa-plus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i></button>-->
							</div>
						</div>

						<p v-if="v$.taskOnlineUserModel.monthCount.required.$invalid && v$.taskOnlineUserModel.monthCount.$dirty" class="mt-3 font-14 font-weight-bold mr-2 color-red2-light text-center">
							<i class="fa fa-exclamation-triangle color-red2-light ml-3 font-22"></i>
							لطفا تعداد ماه را وارد کنید.
						</p>
					</div>

					<button type="button" :disabled="saveLoading" class="btn btn-m mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100 mb-4" @click.prevent="saveUser">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
		</div>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10">
					<i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import useVuelidate from "@vuelidate/core";
	import { required, between, requiredIf, email } from "@vuelidate/validators";
	import "vue-select/dist/vue-select.css";
	export default {
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				modified: false,
				pageLoaded: false,
				saveLoading: false,
				taskOnlineUserModel: {
					id: 0,
					userCode: null,
					gender: true,
					adminUserCode: null,
					parentId: null,
					companyTitle: "",
					phoneNumber: null,
					userTitle: null,
					adminOrUser: false,
					monthCount: 1,
					expireDate: "",
					disabled: false,
					payedMonthCount: 0,
					registByEmail: (this.$route.params.registByEmail == "true"),
					emailAddress: null,
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
		},
		created() {
			if (this.$route.params.id != null && this.$route.params.id != 0) {
				this.GetTaskOnlineUserItem(this.$route.params.id);
			} else {
				this.GetTaskOnlineItem();
			}
		},
		methods: {

			changeMonthRadio(val) {
				this.taskOnlineUserModel.monthCount = val;

			},
			saveUser() {

				this.v$.$touch(); //it will validate all fields
				console.log(this.v$)
				if (!this.v$.$invalid) {
					console.log(this.taskOnlineUserModel);
					//invalid, becomes true when a validations return false
					this.modified = false;
					this.saveLoading = true;
					if (this.taskOnlineUserModel.gender === "true") {
						this.taskOnlineUserModel.gender = true;
					}
					if (this.taskOnlineUserModel.gender === "false") {
						this.taskOnlineUserModel.gender = false;
					}
					this.$http.post("TaskOnline/Add", this.taskOnlineUserModel)
						.then((data) => {
							this.saveLoading = false;
							if (isNaN(data.data)) {
								this.showMessage(data.data);
							} else {
								this.showSuccessMessage("با موفقیت ذخیره شد.");
								this.$router.go(-1);
							}
						});
					this.modified = false;
				}
			},
			changeMonth(val) {
				var c = this.taskOnlineUserModel.monthCount + val;
				if (this.taskOnlineUserModel.payedMonthCount <= c) {
					this.taskOnlineUserModel.monthCount = c;
				}
			},
			GetTaskOnlineItem() {
				this.$http.get("TaskOnline/GetByUserCode").then((data) => {
					this.taskOnlineUserModel.adminUserCode = data.data.adminCode;
					this.taskOnlineUserModel.companyTitle = data.data.companyTitle;
				});
			},
			GetTaskOnlineUserItem(id) {
				this.$http.get("TaskOnline/GetById?id=" + id).then((data) => {
					console.log(data.data);
					this.taskOnlineUserModel = data.data;
					this.taskOnlineUserModel.registByEmail = data.data.registByEmail;
					this.taskOnlineUserModel.emailAddress = data.data.emailAddress;
					this.modified = false;
					this.GetTaskOnlineItem();
				});
			},
			saveHeader() {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) {
					//invalid, becomes true when a validations return false
					this.$http.post("Task/TaskTypeCreate", this.taskOnlineUserModel).then(
						(response) => {
							console.log(response);
							if (response.status == 400 || response.data.success == false) {
								this.$store.dispatch("SetLoading", false);
								var res = response.data.errors.map((a) => a.errorMessage);
								this.showErrorMessage(res.join("\n"));
							} else {
								this.$store.dispatch("SetLoading", false);
								this.showSuccessMessage("با موفقیت ثبت شد.");
								this.taskOnlineUserModel.taskOnlineUserId = parseInt(
									response.data.result
								);
							}
						},
						(error) => {
							this.showErrorMessage("خطا در ارسال اطلاعات");
							this.$store.dispatch("SetLoading", false);
							console.log(error);
						}
					);
				}
			},
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},


			
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach((a) => (a.style.display = "block"));

			document.getElementById("userPhoneNumber").onkeypress = function isNumberKey(evt) {
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57))
					return false;
				return true;
			}
		},
		validations: {
			taskOnlineUserModel: {
				userTitle: {
					required,
				},
				phoneNumber: {
					requiredIfFuctionPhone: requiredIf(function () {
						return this.taskOnlineUserModel.registByEmail.toString() == 'false';
					}),
				},
				emailAddress: {
					email,
					requiredIfFuction: requiredIf(function () {
						return this.taskOnlineUserModel.registByEmail.toString() == 'true';
					}),
				},

				monthCount: {
					between: between(0, 120),
					required,
				},
			},
		},
	};
</script>

<style>
	.draggable-container {
		position: absolute;
		z-index: 9;
	}

	.draggable-header {
		z-index: 10;
	}
</style>
